export default {
  // confirm info/warning
  confirm_Info_Warning: 0,

  // confirm yes_no
  confirm_Yes_No: 1,

  // confirm yes_no_cancel
  confirm_Yes_No_Cancel: 2,

  // confirm delete
  confirm_Delete: 3,

  // confirm Đóng
  confirm_Close: 4,
  
  // confirm yes_no 1 lần
  confirm_Yes_No_Once: 5,
  
  // confirm không hiện lại popup này lần sau
  confirm_Show_Once: 7,
  
  // confirm có không hiện lại popup này lần sau radio
  confirm_Show_Once_With_Radio: 9,

  // messagebox xác nhận với nút đóng được custom text
  confirm_Custom: 10,
};
